import React, { ReactNode, useEffect } from "react";
import PaymentsAppSidebar from "../PaymentsAppSidebar";
import PaymentsAppHeader from "../PaymentsAppHeader";

interface PaymentsAppLayoutProps {
  children: ReactNode;
  documentTitle?: string;
  noPadding?: boolean;
}

const PaymentsAppLayout: React.FC<PaymentsAppLayoutProps> = ({
  children,
  documentTitle,
  noPadding
}) => {
  useEffect(() => {
    if (documentTitle) {
      document.title = `${documentTitle} | Zomentum Payments`;
    } else {
      document.title = "Zomentum Payments";
    }
  }, [documentTitle]);
  return (
    <div className="flex flex-col h-screen shadow-lg">
      <PaymentsAppHeader />
      <div className="flex flex-grow">
        <PaymentsAppSidebar />
        <div className="flex flex-grow bg-white-smoke">
          <div className={`bg-white m-4 rounded flex-grow shadow-md ${noPadding ? "" : "p-6"}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsAppLayout;
